import React from 'react';

import {Pix2PixResult} from "../../api";

import Pix2PixBatchHeader from "./Pix2PixBatchHeader";

import TruncatedText from "../TruncatedText";

interface BatchSummaryItem {
    results: Pix2PixResult;
    included: boolean;
    name: string;
}

interface BatchSummaryProps {
    batchId: string;
    items: BatchSummaryItem[];
    onSelect: (i: number, batchId: string) => void;
    selectedItem: number;
}

class Pix2PixBatchSummary extends React.Component<BatchSummaryProps> {
    public static defaultProps = {
        onSelect: () => {return;}
    };

    public render() {
        return (<table className="results-table">
            <thead>
                <Pix2PixBatchHeader includedResults={this.props.items.filter(item => item.included).map(item => item.results)}/>
            </thead>

            <tbody>
            {
                this.props.items.map((item, i) => <tr key={i} className={i === this.props.selectedItem ? "active" : ""}>
                    <td onClick={() => this.props.onSelect(i, this.props.batchId)}>
                        <TruncatedText text={item.name}/>
                    </td>
                    <td>{item.results.relativeIsletCount.toFixed(2)}</td>
                    <td>{item.results.relativeIsletVolumeTable.toFixed(2)}</td>
                    <td>{item.results.relativeIsletVolumeEllipse.toFixed(2)}</td>
                    <td>{item.results.relativeIsletArea.toFixed(2)}</td>
                    <td>{item.results.relativePurity.toFixed(2)}</td>
                </tr>)
            }
            </tbody>
        </table>);
    }
}


export default Pix2PixBatchSummary;
